import { render, staticRenderFns } from "./CreateMessageModal.vue?vue&type=template&id=2b4eed42&scoped=true&"
import script from "./CreateMessageModal.vue?vue&type=script&lang=js&"
export * from "./CreateMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4eed42",
  null
  
)

export default component.exports